import { render, staticRenderFns } from "./ChartsPlugin.vue?vue&type=template&id=91dfc576&scoped=true"
import script from "./ChartsPlugin.vue?vue&type=script&lang=ts"
export * from "./ChartsPlugin.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./ChartsPlugin.vue?vue&type=style&index=0&id=91dfc576&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "91dfc576",
  null
  ,true
)

export default component.exports